
/*
 * Living Towers School Quote Builder v8
 * Uses Compare-at prices for Tower Gardens and bundles.
 * Accessories use current Shopify prices.
 * Quote only — no cart actions.
 */
(function () {
  "use strict";

  function initializeSchoolBuilder() {
    const root = document.getElementById("lt-school-builder");
    if (!root) return;

    if (root.dataset.ltInitialized === "true") return;
    root.dataset.ltInitialized = "true";

    const cards = Array.from(
      root.querySelectorAll(".lt-product[data-cents]")
    );

    const stickyTotal = document.getElementById("lt-sticky-total");
    const viewEstimate = document.getElementById("lt-view-estimate");
    const printButton = root.querySelector("#lt-print");
    const resetButton = root.querySelector("#lt-reset");
    const warning = root.querySelector("#lt-price-warning");

    const money = function (cents) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(cents / 100);
    };

    const escapeHtml = function (value) {
      return String(value).replace(/[&<>"']/g, function (character) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        }[character];
      });
    };

    const hints = {
      indoor: "Indoor growing: consider LED grow lights and a Germinator.",
      outdoor: "Outdoor growing: consider support cages and compatible extensions.",
      both: "Growing indoors and outdoors? Consider lights for indoor growing and support accessories for outdoor use.",
      greenhouse: "Greenhouse growing: consider extensions, support cages and supplemental lighting if needed."
    };

    // Counts of towers eligible for grow-light savings.
    // Bundles already containing lights are excluded.
    const towerCounts = {
      "tower-garden-flex": 1,
      "tower-garden-flex-and-support-cage-bundle": 1,
      "tower-garden-home": 1,
      "tower-garden-home-with-support-cage-bundle": 1,
      "tower-garden-family-garden": 3,
      "tower-garden-community-garden": 12
    };

    const homeHandles = [
      "tower-garden-home",
      "tower-garden-home-with-support-cage-bundle",
      "tower-garden-indoor-bundle"
    ];

    /*
     * PRICING
     *
     * Tower Gardens and bundles:
     * Use Compare-at price when higher than Shopify price.
     *
     * Accessories:
     * Always use current Shopify price.
     *
     * Custom Liquid must provide:
     * data-cents="..."
     * data-compare-at-cents="..."
     */
    function getUnitPrice(card) {
      const rawPrice = card.dataset.cents;

      if (rawPrice === "" || rawPrice === undefined) {
        return NaN;
      }

      const regularPrice = Number(rawPrice);

      if (!Number.isFinite(regularPrice) || regularPrice <= 0) {
        return NaN;
      }

      const isTowerProduct = Boolean(card.closest("#lt-towers"));

      if (!isTowerProduct) {
        return regularPrice;
      }

      const rawCompareAt = card.dataset.compareAtCents;

      if (
        rawCompareAt === undefined ||
        rawCompareAt === ""
      ) {
        return regularPrice;
      }

      const compareAtPrice = Number(rawCompareAt);

      if (
        Number.isFinite(compareAtPrice) &&
        compareAtPrice > regularPrice
      ) {
        return compareAtPrice;
      }

      return regularPrice;
    }

    let quote = {
      items: [],
      subtotal: 0,
      discount: 0,
      total: 0,
      location: "both",
      hasMissingPrices: false
    };

    function getQuantity(card) {
      const input = card.querySelector('input[type="number"]');
      const quantity = parseInt(input.value, 10);

      return Number.isFinite(quantity)
        ? Math.max(0, Math.min(999, quantity))
        : 0;
    }

    function update() {
      const shoppingChoice = root.querySelector(
        'input[name="lt-shopping"]:checked'
      );

      const locationChoice = root.querySelector(
        'input[name="lt-location"]:checked'
      );

      if (!shoppingChoice || !locationChoice) return;

      const accessoriesOnly = shoppingChoice.value === "accessories";
      const location = locationChoice.value;
      const towerSection = root.querySelector("#lt-towers");

      towerSection.hidden = accessoriesOnly;

      if (accessoriesOnly) {
        towerSection
          .querySelectorAll('input[type="number"]')
          .forEach(function (input) {
            input.value = "0";
          });
      }

      root.querySelector("#lt-location-hint").textContent =
        hints[location] || "";

      cards.forEach(function (card) {
        if (homeHandles.includes(card.dataset.handle)) {
          card.hidden = location === "outdoor";

          if (card.hidden) {
            card.querySelector('input[type="number"]').value = "0";
          }
        }
      });

      const items = [];
      const missingPrices = [];

      let subtotal = 0;
      let qualifyingTowers = 0;
      let lightKits = 0;

      cards.forEach(function (card) {
        if (card.hidden) return;

        if (
          card.closest("#lt-towers") &&
          towerSection.hidden
        ) return;

        const quantity = getQuantity(card);
        if (quantity === 0) return;

        // Compare-at pricing is applied here.
        const unitPrice = getUnitPrice(card);

        if (!Number.isFinite(unitPrice) || unitPrice <= 0) {
          missingPrices.push(card.dataset.title);
          return;
        }

        const item = {
          title: card.dataset.title,
          handle: card.dataset.handle,
          qty: quantity,
          unitPrice: unitPrice,
          amount: unitPrice * quantity
        };

        items.push(item);
        subtotal += item.amount;

        qualifyingTowers += quantity * (
          towerCounts[item.handle] || 0
        );

        if (item.handle === "tower-garden-led-grow-lights") {
          lightKits += quantity;
        }
      });

      const discountedLights = Math.min(
        qualifyingTowers,
        lightKits
      );

      const discount = discountedLights * 3000;
      const total = subtotal - discount;

      quote = {
        items: items,
        subtotal: subtotal,
        discount: discount,
        total: total,
        location: location,
        hasMissingPrices: missingPrices.length > 0
      };

      // LIVE ESTIMATE
      const lines = items.map(function (item) {
        return (
          '<div class="lt-line">' +
          "<span>" +
          escapeHtml(item.qty + " × " + item.title) +
          "</span>" +
          "<strong>" +
          money(item.amount) +
          "</strong>" +
          "</div>"
        );
      });

      if (discount > 0) {
        lines.push(
          '<div class="lt-line lt-discount">' +
          "<span>🌱 Tower Garden + Grow Light Savings (" +
          discountedLights +
          " kits)</span>" +
          "<strong>−" +
          money(discount) +
          "</strong>" +
          "</div>"
        );
      }

      root.querySelector("#lt-summary-lines").innerHTML =
        lines.join("") || "Select products above to begin.";

      root.querySelector("#lt-total").textContent = money(total);

      if (stickyTotal) {
        stickyTotal.textContent = money(total);
      }

      if (warning) {
        warning.hidden = missingPrices.length === 0;

        warning.textContent = missingPrices.length
          ? "Price unavailable for: " +
            missingPrices.join(", ") +
            ". Please check the Shopify product price."
          : "";
      }

      if (printButton) {
        printButton.disabled =
          missingPrices.length > 0 || items.length === 0;
      }
    }

    function resetBuilder() {
      const shoppingChoice = root.querySelector(
        'input[name="lt-shopping"][value="all"]'
      );

      const locationChoice = root.querySelector(
        'input[name="lt-location"][value="both"]'
      );

      if (shoppingChoice) shoppingChoice.checked = true;
      if (locationChoice) locationChoice.checked = true;

      root.querySelectorAll('input[type="number"]').forEach(
        function (input) {
          input.value = "0";
        }
      );

      root.querySelector("#lt-school-name").value = "";

      update();
    }

    function printQuote() {
      update();

      if (quote.hasMissingPrices || quote.items.length === 0) {
        return;
      }

      const school = root.querySelector("#lt-school-name").value.trim();

      const quoteDate = new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
      });

      const locationLabels = {
        indoor: "Indoors",
        outdoor: "Outdoors",
        both: "Both Indoors & Outdoors",
        greenhouse: "Greenhouse"
      };

      const rows = quote.items.map(function (item) {
        return (
          "<tr>" +
          "<td>" + escapeHtml(item.title) + "</td>" +
          "<td>" + item.qty + "</td>" +
          "<td>" + money(item.unitPrice) + "</td>" +
          "<td>" + money(item.amount) + "</td>" +
          "</tr>"
        );
      }).join("");

      const printHtml = `
<!doctype html>
<html lang="en">
<head>
<meta charset="utf-8">
<title>Living Towers - School Tower Garden Quote</title>
<style>
@page { size: letter; margin: .6in; }
body { font-family: Arial, sans-serif; color: #242424; font-size: 12px; line-height: 1.5; }
.quote-header { display: flex; justify-content: space-between; align-items: center; gap: 25px; border-bottom: 2px solid #6f9f22; padding-bottom: 18px; margin-bottom: 22px; }
.quote-logo { max-width: 220px; max-height: 85px; object-fit: contain; }
.contact { text-align: right; font-size: 11px; line-height: 1.65; }
.contact a { color: #242424; text-decoration: none; }
h1 { font-size: 23px; margin: 0 0 8px; }
.meta { margin-bottom: 20px; }
.meta p { margin: 4px 0; }
table { width: 100%; border-collapse: collapse; margin: 20px 0; }
th { background: #f7f9f3; text-align: left; }
th, td { padding: 9px; border-bottom: 1px solid #ddd; }
th:last-child, td:last-child { text-align: right; }
.totals { max-width: 370px; margin: 24px 0 24px auto; }
.total-row { display: flex; justify-content: space-between; gap: 12px; padding: 6px 0; }
.discount { color: #4d8015; font-weight: 700; }
.grand-total { border-top: 2px solid #6f9f22; padding-top: 12px; margin-top: 8px; font-size: 18px; font-weight: 700; }
.terms { background: #f7f9f3; border: 1px solid #d9e5c8; border-radius: 10px; padding: 15px 20px; margin-top: 24px; break-inside: avoid; }
.terms h2 { font-size: 15px; margin: 0 0 8px; }
.terms p { margin: 7px 0; }
.footer { text-align: center; margin-top: 20px; font-size: 10px; color: #555; }
@media print {
  .quote-header, .totals, .terms { break-inside: avoid; }
}
</style>
</head>
<body>
<div class="quote-header">
  <img class="quote-logo" src="https://cdn.shopify.com/s/files/1/0865/7105/7463/files/Living_Towers_Logo_png.png?v=1788201726" alt="Living Towers logo">
  <div class="contact">
    <strong>Living Towers Florida Keys</strong>
    <div><a href="https://livingtowers.com">www.livingtowers.com</a></div>
    <div><a href="mailto:info@livingtowers.com">info@livingtowers.com</a></div>
    <div>(305) 986-0803</div>
  </div>
</div>
<h1>School Tower Garden Quote</h1>
<div class="meta">
  <p><strong>Quote Date:</strong> ${quoteDate}</p>
  ${school ? "<p><strong>Prepared for:</strong> " + escapeHtml(school) + "</p>" : ""}
  <p><strong>Growing Location:</strong> ${escapeHtml(locationLabels[quote.location] || quote.location)}</p>
</div>
<table>
  <thead>
    <tr><th>Product</th><th>Qty</th><th>Unit Price</th><th>Total</th></tr>
  </thead>
  <tbody>${rows}</tbody>
</table>
<div class="totals">
  <div class="total-row">
    <span>Equipment Subtotal</span>
    <span>${money(quote.subtotal)}</span>
  </div>
  ${quote.discount ? `
  <div class="total-row discount">
    <span>Tower Garden + Grow Light Savings</span>
    <span>−${money(quote.discount)}</span>
  </div>` : ""}
  <div class="total-row grand-total">
    <span>Quoted Subtotal</span>
    <span>${money(quote.total)}</span>
  </div>
</div>
<div class="terms">
  <h2>Quote Terms &amp; Purchasing Information</h2>
  <p><strong>Pricing:</strong> This quote is provided for school budgeting and purchasing purposes. Prices are subject to change and will be confirmed when the order is processed.</p>
  <p><strong>Placing Your Order:</strong> A valid purchase order or credit card is required to process the order.</p>
  <p><strong>Sales Tax:</strong> Applicable sales tax will be charged unless the purchasing organization is tax exempt. Tax-exempt customers must provide a valid tax-exemption certificate before the order can be processed without tax.</p>
  <p><strong>Shipping:</strong> Shipping charges, if applicable, are not included and will be confirmed before the order is finalized.</p>
  <p><strong>Fulfillment:</strong> Tower Garden equipment is supplied by Tower Garden. Living Towers can assist with product selection and school purchasing arrangements.</p>
</div>
<div class="footer">
  Thank you for considering Tower Garden for your school!
  <div>Living Towers Florida Keys · www.livingtowers.com</div>
</div>
</body>
</html>`;

      const printWindow = window.open("", "_blank");

      if (!printWindow) {
        alert("Please allow pop-ups to print your school quote.");
        return;
      }

      printWindow.document.open();
      printWindow.document.write(printHtml);
      printWindow.document.close();

      const logo = printWindow.document.querySelector(".quote-logo");
      let printed = false;

      function printOnce() {
        if (printed) return;
        printed = true;
        printWindow.focus();
        printWindow.print();
      }

      if (logo && !logo.complete) {
        logo.addEventListener("load", printOnce, { once: true });
        logo.addEventListener("error", printOnce, { once: true });
        setTimeout(printOnce, 2500);
      } else {
        setTimeout(printOnce, 200);
      }
    }

    root.addEventListener("change", update);

    root.addEventListener("input", function (event) {
      if (event.target.matches('input[type="number"]')) {
        update();
      }
    });

    if (resetButton) {
      resetButton.addEventListener("click", resetBuilder);
    }

    if (viewEstimate) {
      viewEstimate.addEventListener("click", function () {
        root.querySelector("#lt-estimate").scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    }

    if (printButton) {
      printButton.addEventListener("click", printQuote);
    }

    update();

    console.info(
      "Living Towers School Quote Builder v8 initialized."
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeSchoolBuilder
    );
  } else {
    initializeSchoolBuilder();
  }
})();
